var _line, _circle, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLibrary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 556,
    viewBox: "0 0 416 556",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 193.5,
    y1: 50,
    x2: 193.5,
    y2: -2.18557e-8,
    stroke: "#6392EF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 108,
    r: 27,
    fill: "#FFB800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M254 110H194H134C134 76.8629 160.863 50 194 50C227.137 50 254 76.8629 254 110Z",
    fill: "#6392EF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 263,
    width: 16,
    height: 117,
    rx: 2,
    fill: "#6392EF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 263,
    width: 16,
    height: 117,
    rx: 2,
    fill: "#6392EF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 117,
    rx: 2,
    transform: "matrix(-1 0 0 1 53 429)",
    fill: "#E86A50"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 332,
    width: 16,
    height: 86,
    rx: 2,
    transform: "rotate(-90 127 332)",
    fill: "#D5BFF7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 380,
    width: 36,
    height: 86,
    rx: 2,
    transform: "rotate(-90 127 380)",
    fill: "#6392EF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 263,
    width: 36,
    height: 117,
    rx: 2,
    fill: "#D5BFF7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 363,
    y: 288,
    width: 36,
    height: 92,
    rx: 2,
    fill: "#E8AB94"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 288,
    width: 16,
    height: 92,
    rx: 2,
    fill: "#E86A50"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 92,
    rx: 2,
    transform: "matrix(-1 0 0 1 345 454)",
    fill: "#E8AB94"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 92,
    rx: 2,
    transform: "matrix(-1 0 0 1 328 454)",
    fill: "#6392EF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 293.51,
    width: 16,
    height: 92,
    rx: 2,
    transform: "rotate(-20 316 293.51)",
    fill: "#E8AB94"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 288,
    width: 16,
    height: 92,
    rx: 2,
    fill: "#D5BFF7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 246.976,
    y: 287.31,
    width: 16,
    height: 92,
    rx: 2,
    transform: "rotate(10 246.976 287.31)",
    fill: "#6392EF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 288,
    width: 16,
    height: 92,
    rx: 2,
    fill: "#E8AB94"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 263,
    width: 36,
    height: 117,
    rx: 2,
    fill: "#E86A50"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 117,
    rx: 2,
    transform: "matrix(-1 0 0 1 36 429)",
    fill: "#E8AB94"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 270.472,
    width: 16,
    height: 117,
    rx: 2,
    transform: "rotate(-20 71 270.472)",
    fill: "#E86A50"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    y: 379,
    width: 416,
    height: 14,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 92,
    rx: 2,
    transform: "matrix(-1 0 0 1 416 454)",
    fill: "#E86A50"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 86,
    rx: 2,
    transform: "matrix(0 -1 -1 0 311 546)",
    fill: "#D5BFF7"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 86,
    rx: 2,
    transform: "matrix(0 -1 -1 0 311 529)",
    fill: "#6392EF"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 86,
    rx: 2,
    transform: "matrix(0 -1 -1 0 311 512)",
    fill: "#E86A50"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 117,
    rx: 2,
    transform: "matrix(-1 0 0 1 382 429)",
    fill: "#6392EF"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 92,
    rx: 2,
    transform: "matrix(-1 0 0 1 152 454)",
    fill: "#E86A50"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 92,
    rx: 2,
    transform: "matrix(-1 0 0 1 399 454)",
    fill: "#D5BFF7"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 92,
    rx: 2,
    transform: "matrix(-0.939693 -0.34202 -0.34202 0.939693 99 459.51)",
    fill: "#6392EF"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 92,
    rx: 2,
    transform: "matrix(-1 0 0 1 169 454)",
    fill: "#E8AB94"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 92,
    rx: 2,
    transform: "matrix(-1 0 0 1 186 454)",
    fill: "#D5BFF7"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 117,
    rx: 2,
    transform: "matrix(-1 0 0 1 115 429)",
    fill: "#D5BFF7"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 181.122,
    y: 432.881,
    width: 16,
    height: 117,
    rx: 2,
    transform: "rotate(-14 181.122 432.881)",
    fill: "#E8AB94"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 416,
    height: 10,
    transform: "matrix(-1 0 0 1 416 546)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.5da652d88e9e49d1faecf2cff2427eb0.svg";
export { ForwardRef as ReactComponent };